export class DepositWithdraw {
  id: number;
  type: string;
  subType: string;
  currency: string;
  chain: string;
  txHash: string;
  amount: number;
  fromAddrTag: string;
  address: string;
  addressTag: string;
  fee: number;
  state: string;
  createdAt: number;
  updatedAt: number;
}
